import palette from '@lib/core/src/theme/palette';
import { Box, Button, IconButton, Stack, Typography, styled } from '@mui/material';

export const Container = styled(Stack)({
  gap: '24px',
  position: 'relative'
});

export const MeetingBrief = styled(Typography)({
  marginTop: '50px',
  fontSize: '13px',
  fontWeight: 500,
  whiteSpace: 'pre-line'
});

export const MeetingTopic = styled(Typography)({
  fontSize: '13px',
  fontWeight: 500,
  lineHeight: '16px',
  cursor: 'pointer'
});

export const FailedToGenerateWrapper = styled(Stack)({
  background: palette.grey[800],
  minHeight: '150px',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '8px',
  marginTop: '20px',
  gap: '8px'
});

export const SectionTitle = styled('input')({
  all: 'unset',
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: '16px',
  outline: 'none',
  textDecoration: 'none',
  border: '1px solid transparent',
  borderRadius: '8px',
  '&:hover, &:focus': {
    padding: '4px 8px',
    backgroundColor: palette.white,
    border: `1px solid ${palette.grey[1200]}`
  }
});

export const SectionTitleText = styled(Typography)({
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: '16px'
});

export const SectionContent = styled(Box)({
  color: palette.black,
  width: '100%',
  fontSize: '13px',
  fontWeight: 500,
  whiteSpace: 'pre-line',
  '& p, & ul, & ol, & li, & h1, & h2, & h3, & h4, & h5, & h6': {
    marginTop: '0',
    marginBottom: '0'
  },
  '& ul, & ol': {
    paddingLeft: '20px'
  }
});

export const SubTitle = styled(Typography)({
  fontSize: '16px',
  fontWeight: 600
});

export const MeetingTasks = styled(Stack)({
  gap: '16px',
  alignItems: 'flex-start'
});

export const UserTasks = styled(Stack)({
  alignItems: 'flex-start'
});

export const UserTitle = styled(Typography)({
  fontSize: '13px',
  fontWeight: 600,
  lineHeight: '16px'
});

export const TaskTitle = styled(Typography)({
  fontSize: '13px',
  fontWeight: 500,
  lineHeight: '16px'
});

export const SectionItem = styled(Box)({});

export const SelectTemplateButton = styled(IconButton)({
  height: '27px',
  borderRadius: '88px',
  padding: '2px 8px',
  border: `1px solid ${palette.grey[1200]}`,
  boxShadow: 'none',
  backgroundColor: 'transparent',
  color: palette.black,
  fontSize: '12px',
  marginRight: '8px',
  textTransform: 'none'
});

export const TryAgainButton = styled(Button)({
  borderRadius: '88px',
  backgroundColor: palette.black,
  padding: '5px 12px',
  marginTop: '16px',
  alignItems: 'center',
  textTransform: 'none',
  fontSize: '13px',
  color: palette.white,
  fontWeight: 600,
  ':hover': { opacity: 0.8 }
});

export const TemplateSelectorContainer = styled(Stack)({
  flexDirection: 'row-reverse',
  alignItems: 'center',
  position: 'absolute',
  right: '0'
});

export const SelectTemplateButtonContainer = styled(Stack)({
  alignItems: 'center',
  justifyContent: 'space-between'
});
